import React from "react";
import { Provider } from "react-redux";
import { store } from "./Stores/store";
import AppGoogle from "./AppGoogle";
import { LayoutToggleProvider } from "./Components/RedesignLayout/LayoutToggleContext";
import "./utils/apexDefaults";

function App() {
  return (
    <Provider store={store}>
      <LayoutToggleProvider>
        <AppGoogle />
      </LayoutToggleProvider>
    </Provider>
  );
}

export default App;
